import React, { createContext, useContext, useEffect, useState } from "react";
import {
    onAuthStateChanged,
    getIdToken,
    signInAnonymously,
    User,
} from "firebase/auth";
import { auth } from "./firebase";

type FirebaseContextValue = {
    token: string | null;
    uid: string | null;
    loading: boolean;
};

const FirebaseContext = createContext<FirebaseContextValue>({
    token: null,
    uid: null,
    loading: true,
});

export const FirebaseProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const [token, setToken] = useState<string | null>(null);
    const [uid, setUid] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user: User | null) => {
            if (user) {
                const token = await getIdToken(user);
                setToken(token);
                setUid(user.uid);
                setLoading(false);
            } else {
                try {
                    const result = await signInAnonymously(auth);
                    const token = await getIdToken(result.user);
                    setToken(token);
                    setUid(result.user.uid);
                } catch (error) {
                    console.error("Ошибка анонимной авторизации:", error);
                } finally {
                    setLoading(false);
                }
            }
        });

        return () => unsubscribe();
    }, []);

    return (
        <FirebaseContext.Provider value={{ token, uid, loading }}>
            {children}
        </FirebaseContext.Provider>
    );
};

export const useFirebaseToken = () => useContext(FirebaseContext);